import axios from 'axios';

export const getUser = async search => {
	if (search) return { role: 'invite' };
	const stored = localStorage.getItem('crMiniSession');
	if (!stored) return { role: 'guest' };

	return { role: 'guest' };
};

export const getSession = async data => {
	let session = {};
	try {
		session = await axios({
			method: 'post',
			url: `/login`,
			data,
		});
	} catch (e) {
		session = { error: 'xhr error' };
		console.log(e.stack);
	}
	return session;
};

export const setPassword = async data => {
	let session = {};
	try {
		session = await axios({
			method: 'post',
			url: `/signup`,
			data,
		});
	} catch (e) {
		session = { error: 'xhr error' };
		console.log(e.stack);
	}
	return session;
};
